const useIsTeamMember = () => {
    // const userType = useSelector((state: RootState) => state.user.user?.userType);
    return false;
};

export default useIsTeamMember;
